import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import { publications } from '../mockData';
import { Card, CardContent } from './ui/card';

const Publications = () => {
  return (
    <section id="publications" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Research & Publications</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2">Academic Contributions</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Published research advancing the field of internal medicine
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {publications.map((publication) => (
            <Card key={publication.id} className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-100 p-3 rounded-lg flex-shrink-0">
                    <FileText className="h-6 w-6 text-blue-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{publication.title}</h3>
                    <p className="text-gray-600 mb-2">{publication.authors}</p>
                    <div className="flex items-center space-x-4 text-sm">
                      <span className="text-blue-600 font-semibold">{publication.journal}</span>
                      <span className="text-gray-500">{publication.year}</span>
                    </div>
                  </div>
                  <button className="text-blue-600 hover:text-blue-700 transition-colors duration-200">
                    <ExternalLink className="h-5 w-5" />
                  </button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;